var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn row mt-2"},[_c('b-col',{attrs:{"md":"1"}}),_c('b-col',{attrs:{"md":"10"}}),_c('b-col',{attrs:{"md":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }